module.exports = __webpack_public_path__ + "media/images/icons/icon-social-instagram-e86d8d52b7e64ccc9a16fbb44bc362a1.svg";